import React, { Component } from 'react';
import { Container, Form, Button, Label, Image, Message } from 'semantic-ui-react';
import axios from 'axios';
import './App.css';
import { activityOptions, genderOptions } from './utils/options';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      email: '',
      gender: 'F',
      age: '',
      height: '',
      weight: '',
      activity: 1.2,
      loading: false,
      result: '',
      disabled: false,
    }
  }
  handleDropdownChange = (e, { name, value }) => {
    this.setState({ [name]: value });
  }
  handleChangeNumber = (e, { name, value }) => {
    if (/^[0-9]*$/.test(value)) {
      this.setState({
        [name]: value
      });
    }
  }
  handleChange = (e, { name, value }) => {
    this.setState({
      [name]: value
    });
  }
  handleDismiss = () => {
    this.setState({ result: '' })
  }
  calculate = () => {
    // BMR for Men = 66.47 + (13.7 * weight [kg]) + (5 * size [cm]) − (6.8 * age [years])
    // BMR for Women = 655.1 + (9.6 * weight [kg]) + (1.8 * size [cm]) − (4.7 * age [years])
    const { name, email, gender, age, height, weight, activity } = this.state;
    this.setState({ loading: true })
    let bmr;
    if (gender === 'M') {
      bmr = 66.47 + (13.7 * weight) + (5 * height) - (6.8 * age)
    } else if (gender === 'F') {
      bmr = 655.1 + (9.6 * weight) + (1.8 * height) - (4.7 * age)
    }
    console.log(parseInt(bmr, 10))
    console.log(parseInt((bmr * this.state.activity), 10))
    axios.post('https://secret-shore-82958.herokuapp.com/email', {
      name: name,
      email: email,
      bmr: parseInt(bmr, 10),
      maintenance: parseInt((bmr * activity), 10),
    })
    .then((response) => {
      if (response.data.success) {
        this.setState({
          loading: false,
          result: 'success',
          disabled: true,
        })
      } else {
        this.setState({
          loading: false,
          result: 'failure',
        })
      }
    })
    .catch((error) => {
      console.log(error);
      this.setState({ loading: false })
    });
  }
  render() {
    const { loading, name, email, gender, age, height, weight, activity, result, disabled } = this.state;
    return (
      <div className="App">
        <Container>
          <Image
            src={require('./assets/images/fitazfk-wordmark.png')}
            size="large"
            centered
          />
          <h1>BMR Calculator</h1>
          <p>
            Your BMR (Basal Metabolic Rate) is the number of calories you burn in a day when you do nothing... (if you lay in bed watching Netflix the entire day)
          </p>
          <p>
            This calculator will also tell you the number of calories your body needs after taking into account your BMR and amount of exercise you do. You're then able to determine the amount of energy (calories) you have to burn or consume each day to reach your body goals, whether that is losing weight, or gaining weight! Super simple isn't it!
          </p>
          <p>
            {"Calories in < Calories out = LOSE WEIGHT"}
          </p>
          <p>
            {"Calories in > Calories out = GAIN WEIGHT"}
          </p>
          <Form
            onSubmit={this.calculate}
          >
            <Form.Group widths="equal">
              <Form.Field required>
                <Form.Select
                  className="form-field"
                  required
                  name="gender"
                  value={gender}
                  onChange={this.handleDropdownChange}
                  placeholder='Select your gender'
                  fluid
                  selection
                  options={genderOptions}
                  label="Gender"
                />
              </Form.Field>
              <Form.Field required>
                <label>Age</label>
                <Form.Input
                  required
                  name="age"
                  value={age}
                  placeholder="Enter your age"
                  labelPosition='right'
                  onChange={this.handleChangeNumber}
                >
                  <input />
                <Label>years</Label>
                </Form.Input>
              </Form.Field>
            </Form.Group>

            <Form.Group widths="equal">
              <Form.Field required>
                <label>Height</label>
                <Form.Input
                  required
                  name="height"
                  value={height}
                  placeholder="Enter your height"
                  labelPosition='right'
                  onChange={this.handleChangeNumber}
                >
                  <input />
                <Label>cm</Label>
                </Form.Input>
              </Form.Field>

              <Form.Field required>
                <label>Weight</label>
                <Form.Input
                  required
                  name="weight"
                  value={weight}
                  placeholder="Enter your weight"
                  labelPosition='right'
                  onChange={this.handleChangeNumber}
                >
                  <input />
                <Label>kgs</Label>
                </Form.Input>
              </Form.Field>
            </Form.Group>
            <Form.Field
              required
            >
              <Form.Select
                className="form-field"
                required
                name="activity"
                value={activity}
                onChange={this.handleDropdownChange}
                placeholder='Select your activity level'
                fluid
                selection
                options={activityOptions}
                label="Activity Level"
              />
            </Form.Field>

            <Form.Group widths="equal">
              <Form.Field required>
                <label>Name</label>
                <Form.Input
                  required
                  name="name"
                  value={name}
                  placeholder="Enter your name"
                  onChange={this.handleChange}
                />
              </Form.Field>

              <Form.Field required>
                <label>Email</label>
                <Form.Input
                  required
                  name="email"
                  value={email}
                  type="email"
                  placeholder="Enter the email address to send your results to"
                  onChange={this.handleChange}
                />
              </Form.Field>
            </Form.Group>
            <Container className="subscribe-text">
              <p>
                Subscribe to emails from FitazFK for your personalised BMR results, fitness, nutrition, lifestyle and wellness info and exclusive offers.  You can unsubscribe at any time!
              </p>
            </Container>
            {
              result === 'success' &&
              (
                <Message
                  positive
                  onDismiss={this.handleDismiss}
                >
                <Message.Header>Success</Message.Header>
                <p>
                  Your results are being emailed to your chosen email address
                </p>
              </Message>
              )
            }
            {
              result === 'failure' &&
              (
                <Message positive>
                <Message.Header>Uh oh...</Message.Header>
                <p>
                  Something went wrong, please try again later.
                </p>
              </Message>
              )
            }
            <Button
              className="button"
              size="huge"
              type="submit"
              loading={loading}
              disabled={disabled}
            >
              Sign me up now!
            </Button>
          </Form>
        </Container>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js